/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AuthRouteImport } from "./routes/_auth"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AuthVerifyEmailRouteImport } from "./routes/_auth/verify-email"
import { Route as AuthSignupRouteImport } from "./routes/_auth/signup"
import { Route as AuthResetPasswordRouteImport } from "./routes/_auth/reset-password"
import { Route as AuthLoginRouteImport } from "./routes/_auth/login"
import { Route as AuthInviteRouteImport } from "./routes/_auth/invite"
import { Route as AuthForgotPasswordRouteImport } from "./routes/_auth/forgot-password"
import { Route as AppWikiRouteImport } from "./routes/_app/wiki"
import { Route as AppStoresRouteImport } from "./routes/_app/stores"
import { Route as AppSettingsRouteImport } from "./routes/_app/settings"
import { Route as AppProfileRouteImport } from "./routes/_app/profile"
import { Route as AppOnboardingRouteImport } from "./routes/_app/onboarding"
import { Route as AppNotificationsRouteImport } from "./routes/_app/notifications"
import { Route as AppFilesRouteImport } from "./routes/_app/files"
import { Route as AppDashboardRouteImport } from "./routes/_app/dashboard"
import { Route as AppCatalogueRouteImport } from "./routes/_app/catalogue"
import { Route as AppAdminRouteImport } from "./routes/_app/admin"
import { Route as AppWikiIndexRouteImport } from "./routes/_app/wiki/index"
import { Route as AppOrdersIndexRouteImport } from "./routes/_app/orders/index"
import { Route as AppIntegrationsIndexRouteImport } from "./routes/_app/integrations/index"
import { Route as AppWikiPageIdRouteImport } from "./routes/_app/wiki/$pageId"
import { Route as AppStoreOrdersRouteImport } from "./routes/_app/store/orders"
import { Route as AppStoreItemsRouteImport } from "./routes/_app/store/items"
import { Route as AppOrdersOrderIdRouteImport } from "./routes/_app/orders/$orderId"
import { Route as AppIntegrationsProhandelRouteImport } from "./routes/_app/integrations/prohandel"
import { Route as AppIntegrationsFarfetchRouteImport } from "./routes/_app/integrations/farfetch"
import { Route as AppCatalogueStockRouteImport } from "./routes/_app/catalogue/stock"
import { Route as AppCatalogueMatchingRouteImport } from "./routes/_app/catalogue/matching"
import { Route as AppCatalogueImportRouteImport } from "./routes/_app/catalogue/import"
import { Route as AppCatalogueExportRouteImport } from "./routes/_app/catalogue/export"
import { Route as AppCatalogueEditorRouteImport } from "./routes/_app/catalogue/editor"

const AuthRoute = AuthRouteImport.update({
  id: "/_auth",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: "/verify-email",
  path: "/verify-email",
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: "/signup",
  path: "/signup",
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => AuthRoute,
} as any)
const AuthInviteRoute = AuthInviteRouteImport.update({
  id: "/invite",
  path: "/invite",
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => AuthRoute,
} as any)
const AppWikiRoute = AppWikiRouteImport.update({
  id: "/wiki",
  path: "/wiki",
  getParentRoute: () => AppRoute,
} as any)
const AppStoresRoute = AppStoresRouteImport.update({
  id: "/stores",
  path: "/stores",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: "/notifications",
  path: "/notifications",
  getParentRoute: () => AppRoute,
} as any)
const AppFilesRoute = AppFilesRouteImport.update({
  id: "/files",
  path: "/files",
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogueRoute = AppCatalogueRouteImport.update({
  id: "/catalogue",
  path: "/catalogue",
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AppRoute,
} as any)
const AppWikiIndexRoute = AppWikiIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppWikiRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: "/orders/",
  path: "/orders/",
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsIndexRoute = AppIntegrationsIndexRouteImport.update({
  id: "/integrations/",
  path: "/integrations/",
  getParentRoute: () => AppRoute,
} as any)
const AppWikiPageIdRoute = AppWikiPageIdRouteImport.update({
  id: "/$pageId",
  path: "/$pageId",
  getParentRoute: () => AppWikiRoute,
} as any)
const AppStoreOrdersRoute = AppStoreOrdersRouteImport.update({
  id: "/store/orders",
  path: "/store/orders",
  getParentRoute: () => AppRoute,
} as any)
const AppStoreItemsRoute = AppStoreItemsRouteImport.update({
  id: "/store/items",
  path: "/store/items",
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: "/orders/$orderId",
  path: "/orders/$orderId",
  getParentRoute: () => AppRoute,
} as any)
const AppIntegrationsProhandelRoute =
  AppIntegrationsProhandelRouteImport.update({
    id: "/integrations/prohandel",
    path: "/integrations/prohandel",
    getParentRoute: () => AppRoute,
  } as any)
const AppIntegrationsFarfetchRoute = AppIntegrationsFarfetchRouteImport.update({
  id: "/integrations/farfetch",
  path: "/integrations/farfetch",
  getParentRoute: () => AppRoute,
} as any)
const AppCatalogueStockRoute = AppCatalogueStockRouteImport.update({
  id: "/stock",
  path: "/stock",
  getParentRoute: () => AppCatalogueRoute,
} as any)
const AppCatalogueMatchingRoute = AppCatalogueMatchingRouteImport.update({
  id: "/matching",
  path: "/matching",
  getParentRoute: () => AppCatalogueRoute,
} as any)
const AppCatalogueImportRoute = AppCatalogueImportRouteImport.update({
  id: "/import",
  path: "/import",
  getParentRoute: () => AppCatalogueRoute,
} as any)
const AppCatalogueExportRoute = AppCatalogueExportRouteImport.update({
  id: "/export",
  path: "/export",
  getParentRoute: () => AppCatalogueRoute,
} as any)
const AppCatalogueEditorRoute = AppCatalogueEditorRouteImport.update({
  id: "/editor",
  path: "/editor",
  getParentRoute: () => AppCatalogueRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/admin": typeof AppAdminRoute
  "/catalogue": typeof AppCatalogueRouteWithChildren
  "/dashboard": typeof AppDashboardRoute
  "/files": typeof AppFilesRoute
  "/notifications": typeof AppNotificationsRoute
  "/onboarding": typeof AppOnboardingRoute
  "/profile": typeof AppProfileRoute
  "/settings": typeof AppSettingsRoute
  "/stores": typeof AppStoresRoute
  "/wiki": typeof AppWikiRouteWithChildren
  "/forgot-password": typeof AuthForgotPasswordRoute
  "/invite": typeof AuthInviteRoute
  "/login": typeof AuthLoginRoute
  "/reset-password": typeof AuthResetPasswordRoute
  "/signup": typeof AuthSignupRoute
  "/verify-email": typeof AuthVerifyEmailRoute
  "/catalogue/editor": typeof AppCatalogueEditorRoute
  "/catalogue/export": typeof AppCatalogueExportRoute
  "/catalogue/import": typeof AppCatalogueImportRoute
  "/catalogue/matching": typeof AppCatalogueMatchingRoute
  "/catalogue/stock": typeof AppCatalogueStockRoute
  "/integrations/farfetch": typeof AppIntegrationsFarfetchRoute
  "/integrations/prohandel": typeof AppIntegrationsProhandelRoute
  "/orders/$orderId": typeof AppOrdersOrderIdRoute
  "/store/items": typeof AppStoreItemsRoute
  "/store/orders": typeof AppStoreOrdersRoute
  "/wiki/$pageId": typeof AppWikiPageIdRoute
  "/integrations/": typeof AppIntegrationsIndexRoute
  "/orders/": typeof AppOrdersIndexRoute
  "/wiki/": typeof AppWikiIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/admin": typeof AppAdminRoute
  "/catalogue": typeof AppCatalogueRouteWithChildren
  "/dashboard": typeof AppDashboardRoute
  "/files": typeof AppFilesRoute
  "/notifications": typeof AppNotificationsRoute
  "/onboarding": typeof AppOnboardingRoute
  "/profile": typeof AppProfileRoute
  "/settings": typeof AppSettingsRoute
  "/stores": typeof AppStoresRoute
  "/forgot-password": typeof AuthForgotPasswordRoute
  "/invite": typeof AuthInviteRoute
  "/login": typeof AuthLoginRoute
  "/reset-password": typeof AuthResetPasswordRoute
  "/signup": typeof AuthSignupRoute
  "/verify-email": typeof AuthVerifyEmailRoute
  "/catalogue/editor": typeof AppCatalogueEditorRoute
  "/catalogue/export": typeof AppCatalogueExportRoute
  "/catalogue/import": typeof AppCatalogueImportRoute
  "/catalogue/matching": typeof AppCatalogueMatchingRoute
  "/catalogue/stock": typeof AppCatalogueStockRoute
  "/integrations/farfetch": typeof AppIntegrationsFarfetchRoute
  "/integrations/prohandel": typeof AppIntegrationsProhandelRoute
  "/orders/$orderId": typeof AppOrdersOrderIdRoute
  "/store/items": typeof AppStoreItemsRoute
  "/store/orders": typeof AppStoreOrdersRoute
  "/wiki/$pageId": typeof AppWikiPageIdRoute
  "/integrations": typeof AppIntegrationsIndexRoute
  "/orders": typeof AppOrdersIndexRoute
  "/wiki": typeof AppWikiIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_app": typeof AppRouteWithChildren
  "/_auth": typeof AuthRouteWithChildren
  "/_app/admin": typeof AppAdminRoute
  "/_app/catalogue": typeof AppCatalogueRouteWithChildren
  "/_app/dashboard": typeof AppDashboardRoute
  "/_app/files": typeof AppFilesRoute
  "/_app/notifications": typeof AppNotificationsRoute
  "/_app/onboarding": typeof AppOnboardingRoute
  "/_app/profile": typeof AppProfileRoute
  "/_app/settings": typeof AppSettingsRoute
  "/_app/stores": typeof AppStoresRoute
  "/_app/wiki": typeof AppWikiRouteWithChildren
  "/_auth/forgot-password": typeof AuthForgotPasswordRoute
  "/_auth/invite": typeof AuthInviteRoute
  "/_auth/login": typeof AuthLoginRoute
  "/_auth/reset-password": typeof AuthResetPasswordRoute
  "/_auth/signup": typeof AuthSignupRoute
  "/_auth/verify-email": typeof AuthVerifyEmailRoute
  "/_app/catalogue/editor": typeof AppCatalogueEditorRoute
  "/_app/catalogue/export": typeof AppCatalogueExportRoute
  "/_app/catalogue/import": typeof AppCatalogueImportRoute
  "/_app/catalogue/matching": typeof AppCatalogueMatchingRoute
  "/_app/catalogue/stock": typeof AppCatalogueStockRoute
  "/_app/integrations/farfetch": typeof AppIntegrationsFarfetchRoute
  "/_app/integrations/prohandel": typeof AppIntegrationsProhandelRoute
  "/_app/orders/$orderId": typeof AppOrdersOrderIdRoute
  "/_app/store/items": typeof AppStoreItemsRoute
  "/_app/store/orders": typeof AppStoreOrdersRoute
  "/_app/wiki/$pageId": typeof AppWikiPageIdRoute
  "/_app/integrations/": typeof AppIntegrationsIndexRoute
  "/_app/orders/": typeof AppOrdersIndexRoute
  "/_app/wiki/": typeof AppWikiIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/admin"
    | "/catalogue"
    | "/dashboard"
    | "/files"
    | "/notifications"
    | "/onboarding"
    | "/profile"
    | "/settings"
    | "/stores"
    | "/wiki"
    | "/forgot-password"
    | "/invite"
    | "/login"
    | "/reset-password"
    | "/signup"
    | "/verify-email"
    | "/catalogue/editor"
    | "/catalogue/export"
    | "/catalogue/import"
    | "/catalogue/matching"
    | "/catalogue/stock"
    | "/integrations/farfetch"
    | "/integrations/prohandel"
    | "/orders/$orderId"
    | "/store/items"
    | "/store/orders"
    | "/wiki/$pageId"
    | "/integrations/"
    | "/orders/"
    | "/wiki/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/admin"
    | "/catalogue"
    | "/dashboard"
    | "/files"
    | "/notifications"
    | "/onboarding"
    | "/profile"
    | "/settings"
    | "/stores"
    | "/forgot-password"
    | "/invite"
    | "/login"
    | "/reset-password"
    | "/signup"
    | "/verify-email"
    | "/catalogue/editor"
    | "/catalogue/export"
    | "/catalogue/import"
    | "/catalogue/matching"
    | "/catalogue/stock"
    | "/integrations/farfetch"
    | "/integrations/prohandel"
    | "/orders/$orderId"
    | "/store/items"
    | "/store/orders"
    | "/wiki/$pageId"
    | "/integrations"
    | "/orders"
    | "/wiki"
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/_auth"
    | "/_app/admin"
    | "/_app/catalogue"
    | "/_app/dashboard"
    | "/_app/files"
    | "/_app/notifications"
    | "/_app/onboarding"
    | "/_app/profile"
    | "/_app/settings"
    | "/_app/stores"
    | "/_app/wiki"
    | "/_auth/forgot-password"
    | "/_auth/invite"
    | "/_auth/login"
    | "/_auth/reset-password"
    | "/_auth/signup"
    | "/_auth/verify-email"
    | "/_app/catalogue/editor"
    | "/_app/catalogue/export"
    | "/_app/catalogue/import"
    | "/_app/catalogue/matching"
    | "/_app/catalogue/stock"
    | "/_app/integrations/farfetch"
    | "/_app/integrations/prohandel"
    | "/_app/orders/$orderId"
    | "/_app/store/items"
    | "/_app/store/orders"
    | "/_app/wiki/$pageId"
    | "/_app/integrations/"
    | "/_app/orders/"
    | "/_app/wiki/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_auth": {
      id: "/_auth"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_auth/verify-email": {
      id: "/_auth/verify-email"
      path: "/verify-email"
      fullPath: "/verify-email"
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/signup": {
      id: "/_auth/signup"
      path: "/signup"
      fullPath: "/signup"
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/reset-password": {
      id: "/_auth/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/login": {
      id: "/_auth/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/invite": {
      id: "/_auth/invite"
      path: "/invite"
      fullPath: "/invite"
      preLoaderRoute: typeof AuthInviteRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_auth/forgot-password": {
      id: "/_auth/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    "/_app/wiki": {
      id: "/_app/wiki"
      path: "/wiki"
      fullPath: "/wiki"
      preLoaderRoute: typeof AppWikiRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/stores": {
      id: "/_app/stores"
      path: "/stores"
      fullPath: "/stores"
      preLoaderRoute: typeof AppStoresRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings": {
      id: "/_app/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/profile": {
      id: "/_app/profile"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/onboarding": {
      id: "/_app/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/notifications": {
      id: "/_app/notifications"
      path: "/notifications"
      fullPath: "/notifications"
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/files": {
      id: "/_app/files"
      path: "/files"
      fullPath: "/files"
      preLoaderRoute: typeof AppFilesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/dashboard": {
      id: "/_app/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/catalogue": {
      id: "/_app/catalogue"
      path: "/catalogue"
      fullPath: "/catalogue"
      preLoaderRoute: typeof AppCatalogueRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/admin": {
      id: "/_app/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/wiki/": {
      id: "/_app/wiki/"
      path: "/"
      fullPath: "/wiki/"
      preLoaderRoute: typeof AppWikiIndexRouteImport
      parentRoute: typeof AppWikiRoute
    }
    "/_app/orders/": {
      id: "/_app/orders/"
      path: "/orders"
      fullPath: "/orders/"
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/integrations/": {
      id: "/_app/integrations/"
      path: "/integrations"
      fullPath: "/integrations/"
      preLoaderRoute: typeof AppIntegrationsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/wiki/$pageId": {
      id: "/_app/wiki/$pageId"
      path: "/$pageId"
      fullPath: "/wiki/$pageId"
      preLoaderRoute: typeof AppWikiPageIdRouteImport
      parentRoute: typeof AppWikiRoute
    }
    "/_app/store/orders": {
      id: "/_app/store/orders"
      path: "/store/orders"
      fullPath: "/store/orders"
      preLoaderRoute: typeof AppStoreOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/store/items": {
      id: "/_app/store/items"
      path: "/store/items"
      fullPath: "/store/items"
      preLoaderRoute: typeof AppStoreItemsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/orders/$orderId": {
      id: "/_app/orders/$orderId"
      path: "/orders/$orderId"
      fullPath: "/orders/$orderId"
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/integrations/prohandel": {
      id: "/_app/integrations/prohandel"
      path: "/integrations/prohandel"
      fullPath: "/integrations/prohandel"
      preLoaderRoute: typeof AppIntegrationsProhandelRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/integrations/farfetch": {
      id: "/_app/integrations/farfetch"
      path: "/integrations/farfetch"
      fullPath: "/integrations/farfetch"
      preLoaderRoute: typeof AppIntegrationsFarfetchRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/catalogue/stock": {
      id: "/_app/catalogue/stock"
      path: "/stock"
      fullPath: "/catalogue/stock"
      preLoaderRoute: typeof AppCatalogueStockRouteImport
      parentRoute: typeof AppCatalogueRoute
    }
    "/_app/catalogue/matching": {
      id: "/_app/catalogue/matching"
      path: "/matching"
      fullPath: "/catalogue/matching"
      preLoaderRoute: typeof AppCatalogueMatchingRouteImport
      parentRoute: typeof AppCatalogueRoute
    }
    "/_app/catalogue/import": {
      id: "/_app/catalogue/import"
      path: "/import"
      fullPath: "/catalogue/import"
      preLoaderRoute: typeof AppCatalogueImportRouteImport
      parentRoute: typeof AppCatalogueRoute
    }
    "/_app/catalogue/export": {
      id: "/_app/catalogue/export"
      path: "/export"
      fullPath: "/catalogue/export"
      preLoaderRoute: typeof AppCatalogueExportRouteImport
      parentRoute: typeof AppCatalogueRoute
    }
    "/_app/catalogue/editor": {
      id: "/_app/catalogue/editor"
      path: "/editor"
      fullPath: "/catalogue/editor"
      preLoaderRoute: typeof AppCatalogueEditorRouteImport
      parentRoute: typeof AppCatalogueRoute
    }
  }
}

interface AppCatalogueRouteChildren {
  AppCatalogueEditorRoute: typeof AppCatalogueEditorRoute
  AppCatalogueExportRoute: typeof AppCatalogueExportRoute
  AppCatalogueImportRoute: typeof AppCatalogueImportRoute
  AppCatalogueMatchingRoute: typeof AppCatalogueMatchingRoute
  AppCatalogueStockRoute: typeof AppCatalogueStockRoute
}

const AppCatalogueRouteChildren: AppCatalogueRouteChildren = {
  AppCatalogueEditorRoute: AppCatalogueEditorRoute,
  AppCatalogueExportRoute: AppCatalogueExportRoute,
  AppCatalogueImportRoute: AppCatalogueImportRoute,
  AppCatalogueMatchingRoute: AppCatalogueMatchingRoute,
  AppCatalogueStockRoute: AppCatalogueStockRoute,
}

const AppCatalogueRouteWithChildren = AppCatalogueRoute._addFileChildren(
  AppCatalogueRouteChildren,
)

interface AppWikiRouteChildren {
  AppWikiPageIdRoute: typeof AppWikiPageIdRoute
  AppWikiIndexRoute: typeof AppWikiIndexRoute
}

const AppWikiRouteChildren: AppWikiRouteChildren = {
  AppWikiPageIdRoute: AppWikiPageIdRoute,
  AppWikiIndexRoute: AppWikiIndexRoute,
}

const AppWikiRouteWithChildren =
  AppWikiRoute._addFileChildren(AppWikiRouteChildren)

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRoute
  AppCatalogueRoute: typeof AppCatalogueRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppFilesRoute: typeof AppFilesRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppStoresRoute: typeof AppStoresRoute
  AppWikiRoute: typeof AppWikiRouteWithChildren
  AppIntegrationsFarfetchRoute: typeof AppIntegrationsFarfetchRoute
  AppIntegrationsProhandelRoute: typeof AppIntegrationsProhandelRoute
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute
  AppStoreItemsRoute: typeof AppStoreItemsRoute
  AppStoreOrdersRoute: typeof AppStoreOrdersRoute
  AppIntegrationsIndexRoute: typeof AppIntegrationsIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRoute,
  AppCatalogueRoute: AppCatalogueRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppFilesRoute: AppFilesRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppProfileRoute: AppProfileRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppStoresRoute: AppStoresRoute,
  AppWikiRoute: AppWikiRouteWithChildren,
  AppIntegrationsFarfetchRoute: AppIntegrationsFarfetchRoute,
  AppIntegrationsProhandelRoute: AppIntegrationsProhandelRoute,
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
  AppStoreItemsRoute: AppStoreItemsRoute,
  AppStoreOrdersRoute: AppStoreOrdersRoute,
  AppIntegrationsIndexRoute: AppIntegrationsIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthInviteRoute: typeof AuthInviteRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthInviteRoute: AuthInviteRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
